// @ts-nocheck
(() => {
  const quickAddSelector = '[data-qbs-quick-add]';
  const addToCartSelector = '[data-qbs-add-to-cart]';
  const cartIconSelector = '[data-qbs-cart-icon]';
  const TOAST_VISIBLE_MS = 5000;

  let toastHideTimeoutId = 0;

  const toCount = (value) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  };

  const getCartRefs = () => {
    const cartIcon = document.querySelector(cartIconSelector);
    if (!cartIcon) return null;

    const cartBubble = cartIcon.querySelector('[ref="cartBubble"]');
    const cartBubbleCount = cartIcon.querySelector('[ref="cartBubbleCount"]');
    if (!cartBubble || !cartBubbleCount) return null;

    return { cartIcon, cartBubble, cartBubbleCount };
  };

  const renderCartBubble = (nextCount) => {
    const refs = getCartRefs();
    if (!refs) return;

    const { cartIcon, cartBubble, cartBubbleCount } = refs;
    const isEmpty = nextCount <= 0;

    cartBubble.classList.toggle('visually-hidden', isEmpty);
    cartBubbleCount.classList.toggle('hidden', isEmpty);
    cartBubbleCount.textContent = nextCount < 100 ? String(nextCount) : '';
    cartIcon.dataset.qbsCartCount = String(nextCount);

    if (nextCount <= 99) {
      cartBubble.setAttribute('data-maintain-ratio', '');
    } else {
      cartBubble.removeAttribute('data-maintain-ratio');
    }
  };

  const updateCartBubbleFromEvent = (event) => {
    const eventData = event?.detail?.data || {};
    const itemCount = toCount(eventData.itemCount);
    const comingFromProductForm = eventData.source === 'product-form-component';
    const refs = getCartRefs();

    if (!refs) return;

    const currentCount = toCount(refs.cartIcon.dataset.qbsCartCount || refs.cartBubbleCount.textContent || '0');
    const nextCount = comingFromProductForm ? currentCount + itemCount : itemCount;

    renderCartBubble(nextCount);
  };

  const setButtonLoadingState = (button, isLoading) => {
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.classList.toggle('is-loading', isLoading);
  };

  const rootPath = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const getCartAddUrl = () => `${rootPath()}cart/add.js`;

  const getCheckoutUrl = () => `${rootPath()}checkout`;

  const showCartToast = (message, isError = false) => {
    const toast = document.querySelector('[data-qbs-cart-toast]');
    if (!toast) return;

    const title = toast.querySelector('[data-qbs-cart-toast-title]');
    const text = toast.querySelector('[data-qbs-cart-toast-text]');
    const checkout = toast.querySelector('.qbs-cart-toast__checkout');

    if (title) title.textContent = isError ? toast.dataset.errorTitle || '' : toast.dataset.successTitle || '';
    if (text) text.textContent = message || (isError ? toast.dataset.errorText || '' : toast.dataset.successText || '');
    if (checkout instanceof HTMLAnchorElement && !checkout.getAttribute('href')) checkout.href = getCheckoutUrl();

    toast.classList.toggle('qbs-cart-toast_error', isError);
    toast.classList.add('qbs-cart-toast_visible');

    clearTimeout(toastHideTimeoutId);
    toastHideTimeoutId = setTimeout(() => {
      toast.classList.remove('qbs-cart-toast_visible');
    }, TOAST_VISIBLE_MS);
  };

  const ADDED_RESET_MS = 800;
  let addedResetTimeoutId = 0;
  let addedStateButton = null;

  const setAddedState = (button) => {
    button.dataset.added = 'true';
    button.classList.remove('_icon-plus');
    button.classList.add('_icon-check');
    button.setAttribute('aria-label', 'Added');
  };

  const resetAddedState = (button) => {
    button.removeAttribute('data-added');
    button.classList.remove('_icon-check');
    button.classList.add('_icon-plus');
    button.setAttribute('aria-label', 'Quick add');
  };

  const scheduleAddedStateReset = (button) => {
    clearTimeout(addedResetTimeoutId);
    if (addedStateButton) resetAddedState(addedStateButton);
    addedStateButton = button;
    setAddedState(button);
    addedResetTimeoutId = setTimeout(() => {
      resetAddedState(addedStateButton);
      addedResetTimeoutId = 0;
      addedStateButton = null;
    }, ADDED_RESET_MS);
  };

  const buildCartUpdateEvent = (detailData) =>
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {},
        sourceId: 'qbs-quick-add',
        data: detailData,
      },
    });

  const addVariantToCart = async (button) => {
    const variantId = button.dataset.variantId;
    const cartAddUrl = button.dataset.cartAddUrl;
    if (!variantId || !cartAddUrl) return false;

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
          },
        ],
      }),
    });

    const data = await response.json();

    if (!response.ok || data?.status) {
      showCartToast(data?.description || data?.message, true);
      return false;
    }

    document.dispatchEvent(
      buildCartUpdateEvent({
        itemCount: 1,
        source: 'product-form-component',
      })
    );

    showCartToast(data?.product_title ? `${data.product_title} has been added.` : 'Your item has been added.');

    return true;
  };

  const addFormToCart = async (form) => {
    const addButton = form.querySelector(addToCartSelector);
    if (!(addButton instanceof HTMLButtonElement)) return;

    const formData = new FormData(form);
    const quantity = Number.parseInt(formData.get('quantity') || '1', 10) || 1;

    setButtonLoadingState(addButton, true);

    try {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok || data?.status) {
        showCartToast(data?.description || data?.message, true);
        return;
      }

      document.dispatchEvent(
        buildCartUpdateEvent({
          itemCount: quantity,
          source: 'product-form-component',
        })
      );

      showCartToast(data?.product_title ? `${data.product_title} has been added.` : 'Your item has been added.');
    } catch (error) {
      console.error('QBS add to cart failed', error);
      showCartToast('Please try again.', true);
    } finally {
      setButtonLoadingState(addButton, false);
    }
  };

  document.addEventListener('cart:update', updateCartBubbleFromEvent);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.querySelector(addToCartSelector)) return;

    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    addFormToCart(form);
  });

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const quickAddButton = event.target.closest(quickAddSelector);
    if (!(quickAddButton instanceof HTMLButtonElement)) return;

    event.preventDefault();

    if (quickAddButton.disabled) return;

    const productUrl = quickAddButton.dataset.productUrl || '#';
    const hasQuickAddData = Boolean(quickAddButton.dataset.variantId && quickAddButton.dataset.cartAddUrl);

    if (!hasQuickAddData) {
      if (productUrl !== '#') {
        window.location.href = productUrl;
      }
      return;
    }

    setButtonLoadingState(quickAddButton, true);

    try {
      const added = await addVariantToCart(quickAddButton);
      if (added) scheduleAddedStateReset(quickAddButton);
    } catch (error) {
      console.error('QBS quick add failed', error);
    } finally {
      setButtonLoadingState(quickAddButton, false);
    }
  });
})();
